module.exports = __webpack_public_path__ + "static/media/SriLalitha_Logo.73d117ab.png";